/* Copyright (c) 2025 Xperi. All Rights Reserved.  */

import { BrandingUiInfoKeys } from '../../../../core/entities';
import { ServicesClientImpl } from '../../../../core/interactors';
import { Locale, LocaleKeys } from '../../../../core/locale';
import { RootState, useTivoSelector } from '../../../../core/tivo/tivo-redux-wrapper';

import './FilteredGuideFooter.scss';

type FilteredGuideFooterProps = {
    rightSideText: string;
};

export const FilteredGuideFooter = ({ rightSideText }: FilteredGuideFooterProps) => {
    const services = new ServicesClientImpl();

    const channelOptionsOverlay = useTivoSelector(
        (state: RootState) => state.channelOptionsOverlay,
    );

    const secondaryBranding = services.getAppUiImageByKey(
        BrandingUiInfoKeys.APP_ICONS.SECONDARY_BRANDING,
    );

    return (
        <div className="footer-container">
            <img
                className="footer-branding-icon"
                src={secondaryBranding?.imageUrl}
                data-testid="guide-footer-branding-icon"
            />
            <div className="footer-return-text" data-testid="guide-footer-return-text">
                {Locale.getString(LocaleKeys.PRESS_BACK_TO_GO_TO_FULL_GUIDE)}
            </div>
            <div className="footer-select-and-all-channels-text">
                <span data-testid="filtered-guide-footer-action-text">{rightSideText}</span>
                <span className="footer-tip-text-bullet"></span>
                <span data-testid="filtered-guide-footer-category-channel-text">{`${channelOptionsOverlay.channelsType.toLocaleLowerCase()} / ${channelOptionsOverlay.categoriesType.toLocaleLowerCase()}`}</span>
            </div>
        </div>
    );
};
